import { api } from './client'
import { withCustomerIds } from './params'

export function fetchOnlineStatus(customerIds = []) {
  return api
    .get('/charts/online-status', { params: withCustomerIds({}, customerIds) })
    .then((r) => r.data)
}

export function fetchOnlineDevices(customerIds = [], online = true, page = 1, pageSize = 50) {
  return api
    .get('/charts/online-devices', {
      params: withCustomerIds({ online, page, page_size: pageSize }, customerIds),
    })
    .then((r) => r.data)
}

export function fetchOsDistribution(customerIds = []) {
  return api
    .get('/charts/os-distribution', { params: withCustomerIds({}, customerIds) })
    .then((r) => r.data)
}

export function fetchOsDevices(customerIds = [], osLabel, page = 1, pageSize = 50) {
  return api
    .get('/charts/os-devices', {
      params: withCustomerIds(
        { os_label: osLabel, page, page_size: pageSize },
        customerIds,
      ),
    })
    .then((r) => r.data)
}

export function fetchMachineTypes(customerIds = []) {
  return api
    .get('/charts/machine-types', { params: withCustomerIds({}, customerIds) })
    .then((r) => r.data)
}

export function fetchAlertsBySeverity(customerIds = []) {
  return api
    .get('/charts/alerts-by-severity', { params: withCustomerIds({}, customerIds) })
    .then((r) => r.data)
}

export function fetchPatchCompliance(customerIds = []) {
  return api
    .get('/charts/patch-compliance', { params: withCustomerIds({}, customerIds) })
    .then((r) => r.data)
}

export function fetchPostureSummary(customerIds = [], attentionLimit = 10) {
  return api
    .get('/charts/posture-summary', {
      params: withCustomerIds({ attention_limit: attentionLimit }, customerIds),
    })
    .then((r) => r.data)
}

export function fetchPostureDevices(
  customerIds,
  area,
  status,
  page = 1,
  pageSize = 50,
  reason = null,
) {
  return api
    .get('/charts/posture-devices', {
      params: withCustomerIds(
        {
          area,
          status,
          page,
          page_size: pageSize,
          ...(reason ? { reason } : {}),
        },
        customerIds,
      ),
    })
    .then((r) => r.data)
}

export function fetchPostureAttention(
  customerIds = [],
  page = 1,
  pageSize = 50,
  reason = null,
) {
  return api
    .get('/charts/posture-attention', {
      params: withCustomerIds(
        {
          page,
          page_size: pageSize,
          ...(reason ? { reason } : {}),
        },
        customerIds,
      ),
    })
    .then((r) => r.data)
}

export function fetchAntivirusSummary(customerIds = []) {
  return api
    .get('/charts/antivirus-summary', { params: withCustomerIds({}, customerIds) })
    .then((r) => r.data)
}

export function fetchAntivirusDevices(
  customerIds = [],
  bucket,
  page = 1,
  pageSize = 50,
) {
  return api
    .get('/charts/antivirus-devices', {
      params: withCustomerIds(
        { bucket, page, page_size: pageSize },
        customerIds,
      ),
    })
    .then((r) => r.data)
}

export function fetchM365Summary(customerIds = []) {
  return api
    .get('/charts/m365-summary', { params: withCustomerIds({}, customerIds) })
    .then((r) => r.data)
}

export function fetchM365Devices(customerIds, area, status, page = 1, pageSize = 50) {
  return api
    .get('/charts/m365-devices', {
      params: withCustomerIds(
        { area, status, page, page_size: pageSize },
        customerIds,
      ),
    })
    .then((r) => r.data)
}
